export const LOAD = 'binary/unlock/LOAD';
export const LOAD_SUCCESS = 'binary/unlock/LOAD_SUCCESS';
export const LOAD_FAIL = 'binary/unlock/LOAD_FAIL';

export function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],

    payload: {
      client: 'tagging',
      request: {
        method: 'get',
        url: '/api/content-edit/unlockall'
        // url: '/api/content-edit/queue/user-buckets'
      }
    }
  };
}
